// src/services/mockData.ts

import { CompanyDepositRequest } from '@/types/CompanyDepositRequest';
import { ParcelData, LockerAssignment } from '../types';
import { CompanyDepositResponse } from '@/types/CompanyDepositResponse';

const delay = (ms: number) => new Promise((resolve) => setTimeout(resolve, ms));

export const verifyPhone = async (
  phone: string,
  company: string
): Promise<boolean> => {
  await delay(200);
  return phone.length === 9 && Math.random() > 0.3;
};

export const sendOTP = async (): Promise<void> => {
  await delay(200);
};

export const verifyOTP = async (
  phone: string,
  otp: string
): Promise<boolean> => {
  await delay(200);
  return otp === '123456';
};

export const getParcelData = async (barcode: string): Promise<ParcelData> => {
  await delay(200);
  return {
    recipientName: 'Milan Bundalo',
    recipientPhone: '065565327',
  };
};

export const getParcelDataByBarcode = async (
  barcode: string
): Promise<ParcelData> => {
  await delay(200);
  return {
    recipientName: 'Milan Bundalo',
    recipientPhone: '065565327',
  };
};

export const assignLocker = async (
  size: string,
  type: string
): Promise<LockerAssignment> => {
  await delay(200);
  const lockers = ['A-1', 'A-2', 'A-3', 'B-1', 'B-2', 'B-3'];
  return {
    assignmentId: '1',
    lockerId: lockers[Math.floor(Math.random() * lockers.length)],
    lockerSize: size,
    lockerType: type,
    requiresPayment: false,
    amount: undefined,
  };
};

export const calculateAmount = async (
  size: string,
  type: string,
  holdTime: number
): Promise<number> => {
  await delay(200);
  const baseAmount = Math.floor(Math.random() * 1000) / 100;
  const sizeMultiplier = size === 'Small' ? 1 : size === 'Medium' ? 1.5 : 2;
  const typeMultiplier =
    type === 'Regular' ? 1 : type === 'Refrigerated' ? 1.5 : 2;
  const timeMultiplier = 1 + holdTime / 10;
  return baseAmount * sizeMultiplier * typeMultiplier * timeMultiplier;
};

export const fetchLockerAssignment = async (
  phone: string
): Promise<LockerAssignment> => {
  return {
    assignmentId: '1',
    lockerId: 'A1',
    lockerSize: 'Medium',
    lockerType: 'Type',
    amount: 10,
    requiresPayment: true,
  };
};

export const confirmPayment = async (
  assignmentId: string
): Promise<boolean> => {
  return true;
};
export const completeCollection = async (
  assignmentId: string
): Promise<boolean> => {
  return true;
};

export const getCompanies = async (): Promise<
  { id: string; name: string }[]
> => {
  return [
    { id: 'poste-srpske', name: 'Pošte Srpske' },
    { id: 'xexpress', name: 'XExpress' },
    { id: 'euro-express', name: 'EuroExpress' },
    { id: 'manja', name: 'Manja' },
  ];
};

export const createCompanyDeposit = async (
  request: CompanyDepositRequest
): Promise<CompanyDepositResponse> => {
  return {
    lockerId: 'A1',
    accessCode: '',
    expiryTime: '2',
  };
};
